// /login now simply redirects to / where the AuthLock handles everything.
import { Navigate } from "react-router-dom";

export default function Login() {
  return <Navigate to="/" replace />;
}
